import { render, staticRenderFns } from "./optionCustomAdd.vue?vue&type=template&id=56cba651&scoped=true&"
import script from "./optionCustomAdd.vue?vue&type=script&lang=js&"
export * from "./optionCustomAdd.vue?vue&type=script&lang=js&"
import style0 from "./optionCustomAdd.vue?vue&type=style&index=0&id=56cba651&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cba651",
  null
  
)

export default component.exports